import { GTM } from '../../constants';

const appendGtmClassName = (settings, childComponents) => {
  if (!childComponents || Array.isArray(childComponents)) return settings;
  const {
    props: {
      children: [, compChildren]
    }
  } = childComponents;

  if (!compChildren || !Array.isArray(compChildren)) return settings;

  const gtmClassNames = compChildren
    .filter(
      ({
        props: {
          component: { type }
        }
      }) => type === GTM
    )
    .map(
      ({
        props: {
          component: {
            settings: { gtmClassName }
          }
        }
      }) => gtmClassName
    )
    .filter(Boolean)
    .join(' ');
  if (!gtmClassNames.length) return settings;
  const { modifier } = settings;
  const updatedModifier = `${modifier || ''} ${gtmClassNames}`.trim();

  return { ...settings, modifier: updatedModifier };
};

export default appendGtmClassName;
